import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Bannertxt({ rtl }) {
  const className = rtl ? "experienced  p-100 rtl-style" : "experienced  p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>شركة تطوير تطبيقات الهاتف المحمول في دبي</h2>
            <p>
              ننفذ في تيك ريفول وعودنا بخلاف شركة تطوير تطبيقات الجوال. ونقدم في
              شركتنا كـ مطورين تطبيقات في دبي حلول البرمجيات المتكاملة التي تعزز
              استراتيجيتك الرقمية وتدعم أعمالك التجارية بأفضل وأسلس طريقة ممكنة.
            </p>
            <p>
              إذا كنت تبحث عن شركة تصميم تطبيقات الجوال على مستوى عال من
              الابتكار، يمكنك زيارة مكتبنا الجديد في مدينة دبي.
            </p>
            <p>
              منذ باشرنا أعمالنا كـ شركة تطوير التطبيقات دبي أنشأنا محفظة مميزة
              تضم عدد من منتجات الويب الضخمة تشمل مواقع الانترنت والتطبيقات
              وألعاب الجوال وغيرها. وتضم قاعدة عملائنا شركات ناشئة طموحة ومؤسسات
              مرموقة نسعى لتقديم خدماتنا لهم بكل مهارة وإبداع.
            </p>
            <p>
              فريقنا المتخصص في تطوير التطبيقات في دبي مستعد لتزويد عملائنا
              بحلول مصممة حسب الطلب. نساعدك في تيك ريفول بوصفنا مطورين تطبيقات
              على حل المشكلات على الصعيد العملي. سواء طلبت موقع للتسويق
              الالكتروني أو خدمة تطبيق سيارات أجرة بسيط، لن نبني التطبيق فحسب بل
              سنضمن تشغيله بحسب النتائج المناسبة.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              هيا بنا نبدأ
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/dxb/Tek_mob_app.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Bannertxt;
